import type { IntlShape } from "react-intl";
import type InputType from "../../../Input/InputType";
import { JsonInputType } from "../../../Input/JsonInputType";
import { SideName } from "../../../Side/SideName";
import Rectangle from "../Rectangle";

/**
 * @deprecated Use `Bevelled/Corners` instead
 */
export default abstract class Bevelled extends Rectangle {
	public getDimensionsString(input: InputType, intl: IntlShape) {
		if (input.depth) {
			const { depth } = this.formatInputs(input, intl, "decimal");

			const dimensions = super.getDimensionsString(input, intl);

			return `${String(dimensions)}, hoek diepte ${depth} cm`;
		}
		return undefined;
	}

	public calculateSideLength(side: SideName, input: InputType) {
		const depth = Number(input[JsonInputType.Depth]);

		if (!Number.isNaN(depth)) {
			switch (side) {
				case SideName.CornerA:
				case SideName.CornerB:
				case SideName.CornerC:
				case SideName.CornerD:
					return Math.sqrt(depth ** 2 + depth ** 2);
			}
		}

		return super.calculateSideLength(side, input);
	}
}
